import './data-mapping-page.css';
import { Modal, notification } from "antd";
import { TdiNodeModel } from "../../model/tdi-node-model";
import { useEffect, useState } from "react";
import { useGetOutputPreviewMutation } from "../../redux/api/data";
import { useLazyGetDataMapSourceQuery } from "../../redux/api/data-maps";
import { Client } from "../../model/client-model";
import { DataMapSourceModel } from "../../model/data-map-source-model";
import Editor from "react-simple-code-editor";
import { highlight, languages } from "prismjs";

interface PreviewProps {
    client?: Client | undefined,
    open: boolean,
    node?: TdiNodeModel,
    onCancel: (values: any) => void
}

export const PreviewModal: React.FC<PreviewProps> = ({client, open, onCancel}): JSX.Element => {

    const [output, setOutput] = useState<string>('');

    const [previewOutput, { isLoading: isTransforming }] = useGetOutputPreviewMutation();
    const [getDataMapSource, { isFetching: isLoadingSource }] = useLazyGetDataMapSourceQuery();

    useEffect(() => {
        if (!open || !client?.id) return;

        setOutput('');
        getDataMapSource(client.id).unwrap()
            .then((dataMapSource: DataMapSourceModel) => {
                const source = dataMapSource?.source;
                if (!source) {
                    notification.error({
                        message: "No Source Data Found",
                        description: "No data mapping source was found in the database for this client yet.",
                    });
                    return;
                }
                return previewOutput({clientId: client.id, data: source}).unwrap();
            })
            .then(response => {
                if (response) setOutput(response);
            })
            .catch((e) => {
                console.log(e);
                setOutput('');
                notification.error({
                    message: "Preview Failed!",
                    description: e instanceof Error ? e.message : `Failed to convert source data into target output.`
                });
            });
    }, [open, client?.id]);

    const isLoading = isLoadingSource || isTransforming;

    return (<Modal
        title={'Output Preview'}
        closable={true}
        open={open}
        onCancel={onCancel}
        destroyOnClose={true}
        okButtonProps={{ style: { display: 'none' } }}
        cancelButtonProps={{ style: { display: 'none' } }}
        width={960}
        style={{ top: 64 }}
        styles={{
            content: { height: 'calc(100vh - 128px)', display: 'flex', flexDirection: 'column' },
            body: { flex: 1, overflow: 'auto' },
        }}>
        <div className="preview-container">
            <div className="outpreview-container single-column">
                <div className="content-container">
                    <Editor
                        value={isLoading ? 'Loading preview...' : (output || 'No output available for this client.')}
                        onValueChange={() => { }}
                        contentEditable={false}
                        highlight={(output) => highlight(output, languages.xml!, 'xml')}
                        padding={10}
                        style={{
                            minHeight: '100%',
                            background: 'white',
                            border: 'none',
                            fontFamily: '"Fira code", "Fira Mono", monospace',
                            fontSize: 14,
                        }}
                    />
                </div>
            </div>
        </div>
    </Modal>)
}
